







































































































































































































import Vue from "vue";

import GROUP_QUERY from "@/graphql/GroupQuery.gql";
import USERS_QUERY from "@/graphql/UsersQuery.gql";
import SessionEdit from "@/components/SessionEdit.vue";
import SAVE_GROUP_MUTATION from "@/graphql/SaveGroupMutation.gql";
import { SaveGroupMutation, SaveGroupMutationVariables } from "@/graphql/generatedTypes/SaveGroupMutation";
import {
  GroupQuery_group,
  GroupQuery_group_participants,
  GroupQuery_group_sessions
} from "@/graphql/generatedTypes/GroupQuery";
import LeaderSelect from "@/components/LeaderSelect.vue";
import moment from "moment-timezone";
import { RegistrationInput, RoleEnum, SessionInput } from "@/graphql/generatedTypes/globalTypes";
import { NULL_GROUP } from "@/graphql/NullObjects";
import { AlertBar } from "@ct/alert";
import { Rules } from "@ct/validations";
import { uniqBy } from "lodash";

export default Vue.extend({
  name: "GroupsEdit",
  components: { SessionEdit, LeaderSelect, AlertBar },
  apollo: {
    group: {
      query: GROUP_QUERY,
      variables(): { id: string } {
        return {
          id: this.id
        };
      },
      fetchPolicy: "no-cache"
    },
    usersResponse: {
      query: USERS_QUERY,
      manual: true,
      variables() {
        return {
          filterParams: !(this as any).searchUser
            ? null
            : {
                search: (this as any).searchUser
              },
          paginationParams: (this as any).searchUser
            ? null
            : {
                page: (this as any).userPaginationOptions.page || 1,
                perPage: (this as any).userPaginationOptions.perPage || 25
              }
        };
      },
      result({ data, loading }) {
        if (!loading) {
          this.users = uniqBy([...this.users, ...data.users.users], "email");
          this.userPaginationOptions.meta = data.users.meta;
        }
      }
    },
    trainersResponse: {
      query: USERS_QUERY,
      manual: true,
      variables() {
        return {
          paginationParams: {
            page: (this as any).trainersPaginationOptions.page || 1,
            perPage: (this as any).trainersPaginationOptions.perPage || 25
          },
          filterParams: {
            roles: [RoleEnum.TRAINER]
          }
        };
      },
      result({ data, loading }) {
        if (!loading) {
          this.trainers = uniqBy([...this.trainers, ...data.users.users], "email");
          this.trainersPaginationOptions.meta = data.users.meta;
        }
      }
    }
  },
  data() {
    return {
      userPaginationOptions: {
        page: 1,
        perPage: 25,
        meta: {
          totalPages: 1,
          totalCount: 0
        }
      },
      trainersPaginationOptions: {
        page: 1,
        perPage: 25,
        meta: {
          totalPages: 1,
          totalCount: 0
        }
      },
      id: this.$route.params.id,
      group: NULL_GROUP as GroupQuery_group,
      newParticipantEmail: "",
      settings: [],
      users: [] as { email: string; id: string; imgRole: string }[],
      trainers: [] as { email: string; id: string; imgRole: string }[],
      trainerId: "",
      registrations: [] as RegistrationInput[],
      maxParticipants: 5,
      timezones: [
        {
          text: "Central",
          value: "America/Chicago"
        },
        {
          text: "Eastern",
          value: "America/New_York"
        },
        {
          text: "Mountain",
          value: "America/Denver"
        },
        {
          text: "Pacific",
          value: "America/Los_Angeles"
        },
        {
          text: "Western European Time",
          value: "Europe/Lisbon"
        },
        {
          text: "Greenwich Mean Time",
          value: "Europe/London"
        },
        {
          text: "Central European Time",
          value: "Europe/Berlin"
        },
        {
          text: "Eastern European Time",
          value: "Europe/Bucharest"
        }
      ],
      timezone: moment.tz.guess(),
      searchUser: "",
      saveBtnDisabled: false
    };
  },
  computed: {
    usersEmails(): string[] {
      return this.users.map((user: { id: string; email: string }) => user.email);
    },
    maxParticipantsLabel(): string {
      if (this.maxParticipants === 0) {
        return "Unlimited participants";
      }
      return `Limit to ${this.maxParticipants} participants`;
    },
    maxParticipantsLimit(): number {
      return this.group.isOneOnOne ? 2 : 100;
    }
  },
  watch: {
    "group.participants": function watchParticipants(value): void {
      value.forEach((participant: GroupQuery_group_participants) => {
        this.addParticipant(participant.email);
      });
    },
    "group.maxParticipants": {
      immediate: true,
      handler() {
        if (this.$route.params.id) {
          this.maxParticipants = this.group.maxParticipants;
        }
      }
    },
    "group.sessions": function watchTimezone(value): void {
      if (this.$route.params.id) {
        this.timezone = value[0].timezone?.split(" ")[0] || "";

        value.map(function(session: GroupQuery_group_sessions) {
          const offset = session.timezone?.split(" ")[1] || "";

          const rawTime = session.time || ""; // 2000-01-01 23:30:00 UTC
          const utcTime = moment.utc(rawTime, "YYYY-MM-DD HH:mm:ss"); // 2000-01-01T23:30:00Z
          const offsetTime = utcTime.utcOffset(offset); // 2000-01-01T18:30:00-05:00

          session.time = offsetTime.format("YYYY-MM-DD HH:mm:ss"); // 2000-01-01 18:30:00;
        });
      }
    },
    trainerId(newValue, oldValue) {
      if (oldValue || !this.$route.params.id) {
        this.trainers.forEach(trainer => {
          if (trainer.id === newValue) {
            this.addParticipant(trainer.email);
          }
        });
      }
    },
    registrations() {
      (this.$refs.form as HTMLFormElement).validate();
    }
  },
  methods: {
    ...Rules,
    addParticipant(email: string): void {
      if (!this.group.participants) {
        return;
      }

      const alreadyAdded = this.registrations.some(participant => participant.email === email);
      if (alreadyAdded || email === "") return;
      this.registrations.push({ email, _destroy: false });
      this.newParticipantEmail = "";
    },
    syncSessions(newSession: GroupQuery_group_sessions): void {
      if (!this.group.sessions) {
        return;
      }

      this.group.sessions.forEach(session => {
        if (session.time == null) {
          session.time = newSession.time;
        }

        if (session.date == null) {
          let newSessionDate = moment(newSession.date || "", "YYYY-MM-DD HH:mm:ss");
          if (!newSessionDate.isValid()) {
            return;
          }
          session.date = newSessionDate.add(session.order - newSession.order, "weeks").format("YYYY-MM-DD");
        }
      });
    },
    saveGroup: async function saveGroup() {
      this.saveBtnDisabled = true;

      const groupFormValidity = (this.$refs.form as HTMLFormElement).validate();
      const timezoneFormValidity = (this.$refs.timezoneForm as HTMLFormElement).validate();
      const sessionFormValidity = (this.$refs.sessionsForm as HTMLFormElement).validate();
      if (!groupFormValidity || !sessionFormValidity || !timezoneFormValidity) {
        this.saveBtnDisabled = false;
        return;
      }

      const sessions = this.group.sessions.map(
        (session): SessionInput => {
          let { id, name, order, status, time, date } = session;
          const hourHourMinuteMinuteTime = moment(time || "", "YYYY-MM-DD HH:mm:ss").format("HH:mm");
          const timeWithOffset = moment.tz(hourHourMinuteMinuteTime, "HH:mm", this.timezone);
          return {
            id,
            name,
            order,
            status,
            date: date || "",
            time: timeWithOffset.format(),
            timezone: `${this.timezone} ${timeWithOffset.format("Z")}`
          };
        }
      );

      let { id, address1, address2, city, state, zip, isPrivate, virtual, isOneOnOne } = this.group;
      let maxParticipants = this.maxParticipants;
      const { trainerId, registrations } = this;

      if (virtual) {
        address1 = null;
        address2 = null;
        city = null;
        state = null;
        zip = null;
      }

      const result = await this.$apollo.mutate<SaveGroupMutation, SaveGroupMutationVariables>({
        mutation: SAVE_GROUP_MUTATION,
        variables: {
          group: {
            id,
            address1,
            address2,
            city,
            state,
            zip,
            isPrivate,
            isOneOnOne,
            sessions,
            trainerId,
            registrations,
            virtual,
            maxParticipants
          }
        }
      });

      if (!result.data?.saveGroup?.group?.id) {
        this.saveBtnDisabled = false;
        return;
      }

      await this.$router.push({
        name: "group_path",
        params: { id: result.data.saveGroup.group.id }
      });

      await this.$vuetify.goTo(0);
    },
    maxParticipantsRule(): boolean | string {
      if (this.registrations.length <= this.maxParticipants || this.maxParticipants === 0) {
        return true;
      }
      return 'Can\'t be less than the current number of participants.';
    },
    isNumber($event: KeyboardEvent) {
      let keyCode = $event.keyCode;
      if (keyCode < 48 || keyCode > 57) {
        $event.preventDefault();
      }
    },
    endIntersect: async function endIntersect() {
      if (this.userPaginationOptions.page < this.userPaginationOptions.meta.totalPages) {
        this.userPaginationOptions.page++;
        await this.$apollo.queries.usersResponse.refresh();
      }
    },
    endIntersectTrainers: async function() {
      if (this.trainersPaginationOptions.page < this.trainersPaginationOptions.meta.totalPages) {
        this.trainersPaginationOptions.page++;
        await this.$apollo.queries.trainersResponse.refresh();
      }
    }
  }
});
